import gql from 'graphql-tag';

export const GET_ADS = gql`
  query getAds($name: String!) {
    ads: hkdutest_pages(where: { name: { _eq: $name } }) {
      banners(order_by: [{ priority: asc }, { created_at: desc }]) {
        id
        title
        description
        link
        file {
          link
        }
        created_at
      }
    }
  }
`;
